// FaqPage.js — Página dedicada /faq: chat com a Layla (IA) + accordion de FAQ.
// Espelha a FAQPage da landing (chat + perguntas frequentes), reaproveitando o
// componente FAQ (accordion) que já existe no editora-insigne.
import React from "react";
import AIChat from "./AIChat";
import FAQ from "./Faq";
import { TituloDeSecao } from "../ui/TituloDeSecao";

const FaqPage = () => (
  <div className="bg-insigne-bg fundo-abertura min-h-screen pt-[var(--nav-h)] pb-16 text-white">
    {/* Cabeçalho */}
    <div className="px-4 mt-[2rem] mb-[2.5rem]">
      <TituloDeSecao
        centro
        nivel="h1"
        chapeu="Ajuda"
        titulo="Tire suas dúvidas"
        tamanho="text-[3rem] sm:text-[4.2rem]"
        subtitulo={
          <>
            Converse com a <span className="text-insigne-orange font-semibold">Layla</span>, nossa
            assistente virtual, ou consulte as perguntas frequentes abaixo.
          </>
        }
      />
    </div>

    {/* Chat com IA */}
    <div className="w-full max-w-[1366px] mx-auto px-4 sm:px-8 mb-16">
      <AIChat />
    </div>

    {/* FAQ (accordion) */}
    <FAQ />
  </div>
);

export default FaqPage;
